import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';

import { checkSubDomain } from '@api/employerRegistration';
import { matchError } from '@api/util';
import WithRender from './TeamName.html';

@WithRender
@Component({
    validations: {
        subDomain: {
            required,
            isValid: (value: string) => /^[a-zA-Z0-9]*$/.test(value)
        }
    }
})
export default class TeamName extends Vue {

    public $v: any;

    public errorMessage: string = '';

    public unknownError: boolean = false;

    public subDomain: string = '';

    public domainName: string = '.monjin.com';

    public checking: boolean = false;

    public loading: boolean = false;

    public checkDone: boolean = false;

    public isDomainAvailable: boolean = true;

    public hasError(model: string) {
        return this.$v.$dirty && this.$v[model].$error;
    }

    public onSubmit() {

        // Dirty all inputs
        this.$v.$touch();

        if (this.$v.$invalid || !this.isDomainAvailable) {
            return;
        }

        this.loading = true;

        this.$emit('next', 4, this.subDomain);
    }

    public checkDomainAvailability() {
        this.checkDone = false;

        if (this.subDomain.trim().length) {

            if (this.$v.$invalid) {
                return;
            }

            this.checking = true;

            checkSubDomain(this.subDomain)
            .then((response) => {
                this.checking = false;
                this.isDomainAvailable = response;
            })
            .catch(matchError({
                anyError: () => {
                    const message = 'Something went wrong! Please try again later.';

                    this.checking = false;
                    this.errorMessage = message;
                    this.unknownError = true;
                    this.$snackbar.error({ message });
                }
            }))
            .then((x) => {
                this.checking = false;
                this.checkDone = true;
            });
        }
    }
}
